module.exports = __webpack_public_path__ + "assets/img/detailBanner.5eca0eb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pagesInvestment/detailBanner.png
// module id = x3bp
// module chunks = 128